import React from 'react';
import { IRaiseMismatch } from '../api/queries';

const MismatchStatus: React.FC<{ status?: IRaiseMismatch['status'] }> = ({
  status,
}) => {
  if (status === 'resolved') {
    return (
      <span className="bg-green-200 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded">
        Resolved
      </span>
    );
  }

  if (status === 'pending') {
    return (
      <span className="bg-yellow-200 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded">
        Pending
      </span>
    );
  }

  if (status === 'rejected') {
    return (
      <span className="bg-red-200 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded">
        Rejected
      </span>
    );
  }

  return null;
};

export default MismatchStatus;
